import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddLampToolbar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.875 3.4375C6.875 9.29687 3.75 9.6875 3.75 13.2031C3.75 17.1094 6.35416 19.0625 10 19.0625C13.6458 19.0625 16.25 17.1094 16.25 13.2031C16.25 9.6875 13.125 9.29687 13.125 3.4375",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.87451 0.9375H13.1245",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.8125 12.8071H12.1875",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 10.625L10 15",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round"
		})
	]
});
export default SvgAddLampToolbar;
